import {computed, makeObservable, observable} from "mobx";
import type {DashboardDto, WidgetDto, WidgetLayout} from "../../generated/api/base";
import type {AppState} from "../state/AppState";
import type {Organization} from "./Organization";
import type {IModel} from "./Model";
import type {User} from "./User";

export class Dashboard implements IModel {
	private _appState: AppState;

	private _data: DashboardDto;

	constructor(data: DashboardDto, appState: AppState) {
		makeObservable<this, "_data">(this, {
			_data: observable,
			widgets: computed,
			id: computed,
			refId: computed,
			organizationId: computed,
			organization: computed,
			userId: computed,
			user: computed,
			data: computed,
		});
		this._appState = appState;
		this.applyData(data);
	}

	public applyData(data: DashboardDto) {
		this._data = data;
	}

	public get widgets(): WidgetDto[] {
		return this._data.widgetList ?? [];
	}

	public get id(): string {
		return this._data.dashboardID;
	}

	public get refId(): string {
		return this._data.dashboardID;
	}

	public get organizationId(): string {
		return this._data.organizationID;
	}

	public get organization(): Organization {
		return this._appState.organizations.find((o) => o.id === this.organizationId);
	}

	public get userId(): string {
		return this._data.userID;
	}

	public get user(): User {
		return this._appState.actions.findUser(this.userId);
	}

	public get data(): DashboardDto {
		return this._data;
	}

	public get widgetLayoutList(): WidgetLayout[] {
		return this._data.widgetLayoutList;
	}
}
